module.exports = __webpack_public_path__ + "step_1_ico_2.svg?e40e8ff6a08e8d55f1c0abf4ef6ee36a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/step_1_ico_2.svg
// module id = 31
// module chunks = 0